import { render, staticRenderFns } from "./chat-list-sidebar.html?vue&type=template&id=04a624ca&scoped=true&"
import script from "./chat-list-sidebar.js?vue&type=script&lang=js&"
export * from "./chat-list-sidebar.js?vue&type=script&lang=js&"
import style0 from "./chat-list-sidebar.scss?vue&type=style&index=0&id=04a624ca&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04a624ca",
  null
  
)

export default component.exports